export interface IEstabInstalacao {
    id: string;
    idTipo: string;
    tipo: string;
    idSubTipo: string;
    subTipo: string;
    idInstalacao: string;
    instalacao: string;
    instalacaoObj: any;
    quantidadeInstalacoes: number;
    quantidadeLeitos: number;
}

export class EstabInstalacaoModel {
    id: string;
    idTipo: string;
    tipo: string;
    idSubTipo: string;
    subTipo: string;
    idInstalacao: string;
    instalacao: string;
    instalacaoObj: any;
    quantidadeInstalacoes: number;
    quantidadeLeitos: number;

    constructor(obj: IEstabInstalacao) {
        this.id = obj.id ? obj.id : '';
        this.idTipo = obj.idTipo ? obj.idTipo : '';
        this.tipo = obj.tipo ? obj.tipo : '';
        this.idSubTipo = obj.idSubTipo ? obj.idSubTipo : '';
        this.subTipo = obj.subTipo ? obj.subTipo : '';
        this.idInstalacao = obj.idInstalacao ? obj.idInstalacao : '';
        this.instalacao = obj.instalacao ? obj.instalacao : '';
        this.instalacaoObj = obj.instalacaoObj ? obj.instalacaoObj : {};
        this.quantidadeInstalacoes = obj.quantidadeInstalacoes ? obj.quantidadeInstalacoes : 0;
        this.quantidadeLeitos = obj.quantidadeLeitos ? obj.quantidadeLeitos : 0;
    }
}
